import { createSlice } from "@reduxjs/toolkit";

const initialStocksState = {
  entities: null,
  warehouseSearchResult: null,
  warehouse: null,
  totalCount: null,
  listLoading: false,
  actionsLoading: false,
  rejectedStocks: null,
  succeedCount: null,
  failedCount: null,
  status: null,
  file: null,
  exportUrl: null,
  exportStatus:null,
  ImportStatus: null,
  ImportUrl: null,
  message: {
    error: null,
    success: null,
    modalError: null,
  },
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const stocksSlice = createSlice({
  name: "stocks",
  initialState: initialStocksState,
  reducers: {
    catchError: (state, action) => {
      let error =
        action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors : action.payload.error.message;
      if (error.constructor.name === "Object") {
        let temp = [];
        for (let [k, v] of Object.entries(error)) {
          temp.push(`${k}->${v}`);
        }
        error = temp;
      }
      state.message.error = error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getStock
    stocksFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    updateUrls: (state, action) => {
      const { url, file } = action.payload;
      state.actionsLoading = false;
      state.error = null;
      state.images = [...state.images, { url: url, file: file }];
    },
    // findStock
    stocksSearched: (state, action) => {
      const { entities, view } = action.payload;
      state.listLoading = false;
      state.error = null;
      if (view == "cart") {
        state.cartSearchResult = entities;
      } else if (view == "stepper") {
        state.stepperSearchResult = entities;
      }
    },
    // findWarehouse
    warehouseSearched: (state, action) => {
      const { entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.warehouseSearchResult = entities;
    },
    // stock Selected
    stockSelected: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.cartSearchResult = null;
      state.stepperSearchResult = null;
      state.orderListSearchResult = null;
    },
    // stock Selected
    thresholdUpdated: (state, action) => {
      const { message, entity } = action.payload;
      state.actionsLoading = false;
      state.error = null;
      state.message.success = message;
      state.entities = state.entities.map((row) => {
        if (row.product_id == entity.product_id) {
          row.min_qty = entity.min_qty;
          row.max_qty = entity.max_qty;
        }
        return row;
      });
    },
    responseMessageUpdated: (state, action) => {
      state.message.success = null;
      state.message.error = null;
    },
    //find stock by name
    findCustomerByName: (state, action) => {
      const { entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.orderListSearchResult = entities;
    },

    //failedStocks
    failedStocks: (state, action) => {
      const { rejectedStocks, succeed } = action.payload;
      const currentRejectedStock = state.rejectedStocks ? state.rejectedStocks : [];
      state.actionsLoading = false;
      state.rejectedStocks = [...currentRejectedStock, ...rejectedStocks];
      state.succeedCount = succeed;
      state.failedCount = state.rejectedStocks.length;
    },

    //failedThreshold
    failedThreshold: (state, action) => {
      state.actionsLoading = false;
      state.rejectedStocks = action.payload.rejectedStocks;
      state.succeedCount = action.payload.succeedCount;
      state.failedCount = action.payload.failedCount;
    },
    //client side rejected stock

    rejectedStocks: (state, action) => {
      const { rejectedStocks, failedCount } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.rejectedStocks = rejectedStocks;
      state.failedCount = failedCount;
    },
    //deselect warehouse selected for import stock
    removeWarehouse: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.warehouse = null;
    },
    //select warehouse
    selectWarehouse: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.warehouse = action.payload.warehouse;
      state.warehouseSearchResult = null;
    },

    updateStatus: (state, action) => {
      const { status, url } = action.payload;
      state.exportStatus = status;
      state.exportUrl = url;
    },

    updateDownLoadingStatus: (state, action) => {
      state.isDownLoading = action.payload;
    },

    updateImportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.ImportStatus = status;
      state.ImportUrl = url;
    },

    //update message
    updateMessage: (state, action) => {
      const { type, message } = action.payload;
      switch (type) {
        case "error":
          state.message.error = message;
          break;
        case "modalError":
          state.message.modalError = message;
          break;
        case "success":
          state.message.success = message;
          break;
      }
    },
  },
});
